import { signOut } from "firebase/auth";
import { useRouter } from "next/navigation";
import { useCallback } from "react";

import { sessionKey } from "constants/session";
import { auth } from "lib/firebase.config";

const useLogout = () => {
  const router = useRouter();
  const logout = useCallback(async () => {
    const res = await signOut(auth).catch(() => "error");
    if (res !== "error") {
      sessionStorage.removeItem(sessionKey.redirect);
      router.replace("/login");
    }
    return;
  }, [router]);
  return { logout };
};

export default useLogout;
